import React, { useState, useEffect } from "react";
import {
  Box,
  Rating,
  IconButton,
  Grid,
  Card,
  CardContent,
  CardHeader,
  AppBar,
  Tabs,
  Tab,
  Stack,
  Pagination,
} from "@mui/material";
import breakpoints from "assets/theme/base/breakpoints";
import ThumbsUpIcon from "@mui/icons-material/ThumbUp";
import ThumbsDownIcon from "@mui/icons-material/ThumbDown";
import SoftButton from "components/SoftButton";
import SoftBox from "components/SoftBox";
import ApnaSelect from "components/ApnaSelect/location";
import ApnaSelec2 from "components/ApnaSelect";
import GradientLineChart from "examples/Charts/BarCharts/VerticalBarChart copy 2";
import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "examples/Navbars/DashboardNavbar";
import SoftTypography from "components/SoftTypography";
import { baseURL } from "utils/api";
import toast from "react-hot-toast";
import SoftBadge from "components/SoftBadge";
import ArrowUpwardIcon from '@mui/icons-material/ArrowUpward';
import { AllInboxOutlined, ApprovalOutlined, ArrowDownward, CalendarMonth, CalendarViewDayRounded, Download, PendingActionsOutlined, StarBorderOutlined } from "@mui/icons-material";
import Loading from "components/ApnaLoading";
import Skeleton from "react-loading-skeleton";
import { useDispatch, useSelector } from "react-redux";
import { getLocationData } from "api/commonSlice";
import CustomDate from "./customDate";
import NotFound from "components/notFound";
import SoftInput from "components/SoftInput";
import useMediaQuery from "@mui/material/useMediaQuery";


const ReviewSection = () => {
  
  const matches = useMediaQuery("(max-width:600px)");
  const userTheme = useSelector((state) => state.commonSlice.theme);
  const [selectedLocation, setSelectedLocation] = useState("default");
  const [reviews, setReviews] = useState([]);
  const [loading, setLoading] = useState(true);
  const [loadingDashboard, setLoadingDashboard] = useState(true);
  const id = localStorage.getItem("id");
  const [reviewsDashboard, setReviewsDashboard] = useState({});
  const [tabsOrientation, setTabsOrientation] = useState("horizontal");
  const [tabValue, setTabValue] = useState(0);
  const [startCount, setStartCount] = useState(null);
  const locations = useSelector((state) => state.commonSlice?.locations);
  const dispatch = useDispatch();
  const filterLocation = useSelector((state) => state.searchSlice?.filterLocation);
  const [allLocations, setAllLocations] = useState([]);
  const [show, setShow] = useState(false)
  const [startDate, setStartDate] = useState(null);
  const [endDate, setEndDate] = useState(null);
  const [dateValue, setDateValue] = useState('');
  const [searchQuery, setSearchQuery] = useState('');
  const [totalPage, setTotalPage] = useState(1);
  const [page, setPage] = useState(1);
  const [thumb, setThumb] = useState('thumbs_up')

  const [gradientLineChartData, setGradientLineChartData] = useState({
    labels: [],
    datasets: [
      {
        label: "Reviews Rating %",
        color: "info",
        data: [],
      },
    ],
  });

  const [ratingsData, setReviewsData] = useState({
    5: 0,
    4: 0,
    3: 0,
    2: 0,
    1: 0
  });

  useEffect(() => {
    dispatch(getLocationData());
  }, []);

  const handleLocationChange = (event) => {
    setSelectedLocation(event.target.value);
  };

  useEffect(() => {
    if (locations) {
      setAllLocations([]);
      locations &&
        locations.length > 0 &&
        locations.map((location) => {
          setAllLocations((prev) => [...prev, { _id: location?.locationId, name: location?.locationName }]);
        })
    }
  }, [locations]);


  useEffect(() => {
    // A function that sets the orientation state of the tabs.
    function handleTabsOrientation() {
      return window.innerWidth < breakpoints.values.sm
        ? setTabsOrientation("vertical")
        : setTabsOrientation("horizontal");
    }
    window.addEventListener("resize", handleTabsOrientation);
    handleTabsOrientation();
    return () => window.removeEventListener("resize", handleTabsOrientation);

  }, [tabsOrientation]);

  const handleSetTabValue = (event, newValue) => setTabValue(newValue);

  const fetchReviews = async (start, ev, locationId, startDate, endDate, search, page) => {
    setLoading(true);
    fetch(`${baseURL}/all-reviews-for-merchant-dashboard/${id}?page=${page}&locationId=${locationId}&${start != null ? `starRating=${start}&` : ''}reviewStatus=${ev == 0 ? "all" : ev == 1 ? 'pending' : ev == 2 ? 'published' : ev == 3 ? 'rejected' : "all"}${startDate != null ? `&startDate=${startDate}` : ''}${endDate != null ? `&endDate=${endDate}` : ''}${search.length > 0 ? `&searchdata=${search}` : ''}`, {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
        Authorization: `${localStorage.getItem("token")}`,
      },
    }).then((res) => res.json())
      .then((resp) => {
        if (resp.status === 200) {
          setReviews(resp.data);
          setLoading(false);
          setTotalPage(resp?.totalPages);
        } else {
          toast.error(resp.message);
        }
      });
  };

  const fetchReviewDashboard = (locationId, startDate, endDate) => {
    setLoadingDashboard(true);
    fetch(`${baseURL}/star-rating-details-for-merchant-dashboard/${id}/${locationId}/${startDate == null ? null : new Date(startDate).toISOString().slice(0, 10)}/${endDate == null ? null : new Date(endDate).toISOString().slice(0, 10)}`)
      .then(res => res.json())
      .then(data => {
        if (data.status === 200) {
          setReviewsDashboard(data?.data);
          setReviewsData({
            5: data?.data?.Five_Star_Percentage,
            4: data?.data?.Four_Star_Percentage,
            3: data?.data?.Three_Star_Percentage,
            2: data?.data?.Two_Star_Percentage,
            1: data?.data?.One_Star_Percentage
          });
        }
        setLoadingDashboard(false);
      }).catch(err => {
        toast.error(err.message || 'Something went wrong');
      });
  };
  const fetchReviewDashboardData = (locationId, startDate, endDate, thumb) => {
    setLoadingDashboard(true);
    fetch(`${baseURL}/reviewTagBarChartData/${id}/${thumb}/${locationId}/${startDate == null ? null : new Date(startDate).toISOString().slice(0, 10)}/${endDate == null ? null : new Date(endDate).toISOString().slice(0, 10)}`)
    // fetch(`${baseURL}/reviewTagBarChartData/${id}/${thumb}/${locationId}/Wed%20Jan%2001%202020%2000:00:00%20GMT+0530%20(India%20Standard%20Time)/Sun%20Jan%2026%202025%2012:40:19%20GMT+0530%20(India%20Standard%20Time)`)
      .then(res => res.json())
      .then(data => {
        if (data.status === 200) {
          setGradientLineChartData({
            labels: data?.data?.categoryIdList,
            datasets: [
              {
                label: "Percentage %",
                color: "info",
                data: data?.data?.categoryPercentageList,
              },
            ],
          });
        }
        setLoadingDashboard(false);
      }).catch(err => {
        toast.error(err.message || 'Something went wrong');
      });
  };

  useEffect(() => {
    fetchReviews(startCount, tabValue, selectedLocation, startDate, endDate, searchQuery, 1);
    fetchReviewDashboard(selectedLocation, startDate, endDate);
    fetchReviewDashboardData(selectedLocation, startDate, endDate, thumb);
  }, [startCount, tabValue, selectedLocation, dateValue]);


  const handleUpdateReview = async (status, id) => {
    fetch(`${baseURL}/update-review-status/${id}`, {
      method: "PUT",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${localStorage.getItem("token")}`,
      },
      body: JSON.stringify({
        status: status,
      }),
    }).then((res) => res.json())
      .then((resp) => {
        if (resp.status === 200) {
          toast.success(resp.message);
          fetchReviews(startCount, tabValue, filterLocation, startDate, endDate, searchQuery, 1);
        } else {
          toast.error(resp.message);
        }
      }).catch((err) => {
        toast.error(err.message || 'Something went wrong');
      });
  };

  const handleChangeDate = (event) => {
    if (event.target.value === "") {
      setDateValue(null);
      setStartDate(null);
      setEndDate(null);
    }
    if (event.target.value === "Today") {
      setStartDate(new Date().toISOString());
      setEndDate(new Date(new Date().setDate(new Date().getDate() + 1)).toISOString());
      setDateValue(event.target.value);
    }
    if (event.target.value === "This Week") {
      const currentDate = new Date();
      const firstDayOfWeek = new Date(currentDate); // Clone the date
      firstDayOfWeek.setDate(currentDate.getDate() - currentDate.getDay()); // Set to the first day of the week (Sunday)

      const lastDayOfWeek = new Date(firstDayOfWeek); // Clone the first day of the week
      lastDayOfWeek.setDate(firstDayOfWeek.getDate() + 6); // Set to the last day of the week (Saturday)

      setStartDate(firstDayOfWeek.toISOString());
      setEndDate(lastDayOfWeek.toISOString());
      setDateValue(event.target.value);
    }

    if (event.target.value === "This Month") {
      const currentDate = new Date();

      // Check if the current date is the last day of December
      if (currentDate.getMonth() === 11 && currentDate.getDate() === 31) {
        // Set the first day of January for the next year
        const firstDayOfNextMonth = new Date(currentDate.getFullYear() + 1, 0, 1); // January 1st
        const lastDayOfNextMonth = new Date(currentDate.getFullYear() + 1, 1, 0); // Last day of January
        setStartDate(firstDayOfNextMonth.toISOString());
        setEndDate(lastDayOfNextMonth.toISOString());
      } else {
        // Normal behavior for the current month
        const firstDayOfMonth = new Date(currentDate.getFullYear(), currentDate.getMonth(), 1); // First day of the month
        const lastDayOfMonth = new Date(currentDate.getFullYear(), currentDate.getMonth() + 1, 0); // Last day of the month
        setStartDate(firstDayOfMonth.toISOString());
        setEndDate(lastDayOfMonth.toISOString());
      }

      setDateValue(event.target.value);
    }

    if (event.target.value === "This Year") {
      const currentYear = new Date().getFullYear();
      const firstDayOfYear = new Date(currentYear, 0, 1);
      const lastDayOfYear = new Date(currentYear, 11, 31);
      setStartDate(firstDayOfYear.toISOString());
      setEndDate(lastDayOfYear.toISOString());
      setDateValue(event.target.value);
    }

    if (event.target.value === "Custom") {
      setShow(true);
    }
  };



  const onSearchChange = (e) => {
    const value = e.target.value;
    setSearchQuery(value);
    fetchReviews(startCount, tabValue, selectedLocation, startDate, endDate, value, 1);
  };


  const handlePageChange = (page) => {
    setPage(page);
    fetchReviews(startCount, tabValue, selectedLocation, startDate, endDate, searchQuery, page);
  }

  const handleFilterChange = (event) => {
    setThumb(event.target.value);
    fetchReviewDashboardData(selectedLocation, startDate, endDate, event.target.value);
  }





  return (

    <DashboardLayout>
      <DashboardNavbar />

      <CustomDate show={show} setDateValue={setDateValue} setShow={setShow} startDate={startDate} setStartDate={setStartDate} endDate={endDate} setEndDate={setEndDate} />

      <SoftBox p={2}>
        <Grid container spacing={1} >
          <Grid item xs={12} md={5}>
            <SoftBox mb={2}>
              <SoftTypography variant="h6">Filters </SoftTypography>
              <SoftBox
                sx={{
                  display: "flex",
                  alignItems: "center",
                }}
              >
                <SoftBox mr={2}>
                  <ApnaSelect
                    origin="Location"
                    value={selectedLocation}
                    options={allLocations}
                    onChange={handleLocationChange}
                  />
                </SoftBox>
                <SoftBox mr={2}>
                  <ApnaSelec2
                    origin="date"
                    value={dateValue}
                    options={[{ name: "Today" }, { name: "This Week" }, { name: "This Month" }, { name: "This Year" }, { name: "Custom" }]}
                    onChange={handleChangeDate}
                  />
                </SoftBox>

              </SoftBox>
            </SoftBox>
            <SoftBox
              sx={{
                display: "flex",
                // flexWrap: "wrap",
                marginTop: 2,
                marginBottom: 2,
                width:"100%"
              }}
            >
              {
                loadingDashboard ? <Skeleton width={200} height={200} /> :

                  <Card sx={{ marginRight: 3 }} className="glassmorphism-card">
                    <SoftBox py={3} px={2} m={1} >
                      <SoftBox sx={{ display: "flex", alignItems: 'center' }}>
                        <IconButton>
                          <ThumbsUpIcon sx={{ color: "#4caf50" }} />
                        </IconButton>
                        <ArrowUpwardIcon color="success" />
                        <SoftTypography variant="h6" color="success">
                          {(reviewsDashboard?.Thumbs_Up_Percentage || 0) + "% "}
                        </SoftTypography>{" "}
                      </SoftBox>
                      <SoftTypography variant="h6" >
                        Positive Review ({reviewsDashboard?.Thumbs_Up || 0})
                      </SoftTypography>
                      <SoftTypography variant="caption" sx={{ display: "flex", alignItems: 'center' }}>
                        {" " + reviewsDashboard?.periodText}
                      </SoftTypography>
                    </SoftBox>
                  </Card>
              }
              {
                loadingDashboard ? <Skeleton width={200} height={200} /> :
                  <Card className="glassmorphism-card">
                    <SoftBox py={3} px={2} m={1} >
                      <SoftBox sx={{ display: "flex", alignItems: "center" }}>
                        <IconButton>
                          <ThumbsDownIcon sx={{ color: "#f44336" }} />
                        </IconButton>
                        <ArrowDownward color="error" />     <SoftTypography variant="h6" color="error"> {reviewsDashboard?.Thumbs_Down_Percentage} </SoftTypography>  {" "}
                      </SoftBox>
                      <SoftTypography variant="h6" >
                        Negative Review ({reviewsDashboard?.Thumbs_down || 0})
                      </SoftTypography>
                      <SoftTypography variant="caption" sx={{ display: "flex", alignItems: "center" }}>
                        {reviewsDashboard?.periodText || 'N/A'}
                      </SoftTypography>
                    </SoftBox>
                  </Card>
              }
            </SoftBox>

            <SoftBox mr={matches?0:2} mt={1}>
              <Card className="glassmorphism-card">
                <SoftBox ml={1} p={2} className="ratings-chart">
                  <SoftBox my={1}>
                    <SoftTypography>Reviews <StarBorderOutlined />
                    </SoftTypography>
                  </SoftBox>
                  {Object.keys(ratingsData)
                    .sort((a, b) => b - a) // Sort ratings from 5 to 1
                    .map((rating) => (
                      <div key={rating} className="rating-row">
                        <SoftTypography variant="caption" className="rating-label">{rating}.0</SoftTypography>
                        <div className="rating-bar">
                          <div
                            className="rating-fill"
                            style={{ width: `${ratingsData[rating]}%` }}
                          ></div>
                        </div>
                      </div>
                    ))}
                </SoftBox>
              </Card>
            </SoftBox>
          </Grid>

          {/* Submit Review */}
          <Grid item xs={12} lg={7}>
            <GradientLineChart
              title={`Response (${reviewsDashboard?.Total || 0})`}
              description={
                'Reviewee answer'
              }
              height="20.25rem"
              chart={gradientLineChartData}
              option={[{ name: "Thumbs Up",_id:'thumbs_up' }, { name: "Thumbs Down",_id:'thumbs_down' }]}
              handleFilterChange={handleFilterChange}
              selectedFilter={thumb}
            />
          </Grid>

        </Grid>

        {/* Reviews List */}
        <Box sx={{ marginTop: 5, }}>

          <Grid item xs={12} md={6} lg={4} sx={{ ml: "auto" }}>
            <AppBar position="static">
              <Tabs
                orientation={tabsOrientation}
                value={tabValue}
                onChange={handleSetTabValue}
                sx={{
                  background: userTheme === "dark" ? "rgba(0, 0, 0, 0.8) !important" : "rgba(124, 124, 124, 0.1) !important",
                  color: userTheme === "dark" ? "white !important" : "black !important",
                  "& .MuiTab-root": {
                    color: userTheme === "dark" ? "white" : "gray", // Unselected tab color
                    textTransform: "none", // Optional: Keeps the text casing as provided
                  },
                  "& .Mui-selected": {
                    backgroundColor: userTheme === "dark" ? "rgba(0, 0, 0, 0.8) !important" : "rgba(227, 227, 227, 0.8) !important",
                    color: userTheme === "dark" ? "white !important" : "black !important", // Selected tab text color
                  },
                  "& .MuiTab-root:not(.Mui-selected)": {
                    color: userTheme === "dark" ? "white" : "gray !important", // Ensure unselected tab text color
                  },
                  "& .MuiTab-root:hover": {
                    backgroundColor: userTheme === "dark" ? "rgba(50, 50, 50, 0.8)" : "rgba(240, 240, 240, 0.8)", // Hover effect for tabs
                  },
                }}
              >
                <Tab label="All" icon={<AllInboxOutlined />} />
                <Tab label="Pending" icon={<PendingActionsOutlined />} />
                <Tab label="Published" icon={<AllInboxOutlined />} />
                <Tab label="Rejected" icon={<ApprovalOutlined />} />
              </Tabs>

            </AppBar>
          </Grid>
          <SoftBox>

            <SoftBox sx={{ display: "flex", justifyContent: "space-between", flexWrap: "wrap" }}>
              <SoftBox p={2}>
                <SoftTypography variant="h5" gutterBottom color="info">
                  Reviews
                </SoftTypography>
                <SoftTypography variant="caption" color="textSecondary">
                  *Only customer feedback goes through the approval process. Ratings and Reviews are auto-published.
                </SoftTypography>
              </SoftBox>

              <SoftBox >
                <SoftTypography variant="caption" color="textSecondary">
                  Star Ratings
                </SoftTypography>
                <ApnaSelec2
                  origin="Star rate"
                  value={startCount}
                  options={[{ name: "1" }, { name: "2" }, { name: "3" }, { name: "4" }, { name: "5" }]}
                  onChange={(e) => setStartCount(e.target.value)}
                />
              </SoftBox>

              <SoftBox p={2}>

                <SoftInput
                  onChange={onSearchChange}
                  placeholder="Search here..."
                  icon={{ component: "search", direction: "left" }}
                />

              </SoftBox>
            </SoftBox>

            {loading ? <Loading /> : reviews && reviews?.length > 0 ? reviews.map((review) => (
              <Card key={review?.id} sx={{ marginBottom: 2 }} className="glassmorphism-card" >
                <CardHeader

                  title={
                    <SoftBox sx={{
                      display: "flex",
                      alignItems: "center",
                      // justifyContent: "space-between",
                      // width:"80%",
                    }}>
                      <SoftTypography variant="h6">{`${review?.firstName + " " + review?.lastName}`}</SoftTypography>

                    </SoftBox>
                  }
                  subheader={<SoftBox sx={{
                    display: "flex",
                    // alignItems: "center",
                    flexDirection: "column", padding: 1
                  }}>
                    <SoftBox sx={{
                      display: "flex"
                    }}>
                      <SoftTypography variant="caption" color="textSecondary">
                        {review?.city + " "}{review?.state + "    "} . {"   "} <CalendarMonth /> {review?.reviewDate}
                      </SoftTypography>

                    </SoftBox>
                    <SoftBox sx={{
                      display: "flex",
                      flexWrap: "wrap",
                    }}>
                      <Rating value={review?.starRating} readOnly sx={{ marginTop: 1 }} />
                      <SoftBox

                      >
                        {
                          review?.reviewTags && review?.reviewTags.length > 0 && review?.reviewTags.map((tag) => (
                            <SoftBadge color="info" badgeContent={tag} size="sm"
                            />
                          ))
                        }
                      </SoftBox>
                    </SoftBox>
                  </SoftBox>

                  }
                  action={
                    <SoftBox sx={{ display: "flex", alignItems: "center", flexWrap: "wrap" }}>
                      <SoftBadge
                        variant="gradient"
                        circular={true}
                        color={review?.status == 0 ? 'warning' : review?.status == 1 ? 'success' : review?.status == 2 ? 'error' : 'warning'}
                        badgeContent={review?.status == 0 ? "Pending" : review?.status == 1 ? "Published" : review?.status == 2 ? "Rejected" : "Pending"}
                        size="lg"
                        sx={{ margin: 1 }}
                      />

                    </SoftBox>
                  }
                />
                <CardContent>
                  <SoftBox sx={{ display: "flex", alignItems: "center", justifyContent: "space-between" }}>

                    <SoftTypography variant="body2">
                      <strong>Review:</strong> {review?.reviewText || "No Review Text"}
                    </SoftTypography>

                    <SoftBox>
                      {
                        review?.status == 0 &&
                        <SoftButton
                          sx={{ marginRight: 1 }}
                          variant="gradient"
                          color="info"
                          onClick={() => handleUpdateReview(1, review?._id)}
                        >
                          Approve
                        </SoftButton>
                      }
                      {
                        review?.status == 0 &&
                        <SoftButton
                          color="info"
                          variant="outlined"
                          onClick={() => handleUpdateReview(2, review?._id)}
                          m={1}>
                          Reject
                        </SoftButton>
                      }
                    </SoftBox>
                  </SoftBox>

                </CardContent>
              </Card>
            )) : <NotFound />}

            <Stack spacing={5} m={5} sx={{ display: "flex", alignItems: 'center', justifyContent: "center" }}>
              <Pagination
                onChange={(event, page) => handlePageChange(page)}
                count={totalPage}
                variant="outlined"
                sx={{
                  '& .MuiPaginationItem-root': {
                    color: 'gray', // Inactive color
                    borderColor: "gray"
                  },
                  '& .Mui-selected': {
                    color: '#ffffff', // Active color
                    borderColor: "#ffffff",
                  },
                }}
                shape="rounded"
              />
            </Stack>
            {/* <SoftBox m={2} display="flex" gap={2} alignItems='center' justifyContent='center' >
              <SoftButton variant="contained" color="black"
              >

                <img
                  src={require("../../assets/images/xls.png")}
                  alt="excel"
                  style={{ width: "30px", height: "30px", marginRight: "10px" }}
                />
                
                <SoftBox ml={1} mt={1}>
                  <Download />
                </SoftBox>
              </SoftButton>
              <SoftButton variant="contained" color="black"
              // onClick={exportToPDF}
              >
                <img
                  src={require("../../assets/images/pdff.png")}
                  alt="excel"
                  style={{ width: "30px", height: "30px", marginRight: "10px" }}
                />
                
                <SoftBox ml={1} mt={1}>
                  <Download />
                </SoftBox>
              </SoftButton>
            </SoftBox> */}
          </SoftBox>

        </Box>
      </SoftBox>
    </DashboardLayout>
  );
};

export default ReviewSection;


